export const REGISTRY_VERSION = 2;

export const ConfigKey = {
    // game server aka server.conf files
    KEY_SERVER: 'server',
    KEY_GAMESERVER: 'gameserver',
    KEY_APISERVER: 'apiserver',
    KEY_URL_FORGOT_PW: 'urlForgotPW',
    KEY_URL_REACTIVATION: 'urlReactivation',
    KEY_CARD_SVG: 'cardsvg',

    // user settings
    KEY_LOGIN_NAME: "LoginName",
    KEY_LOGIN_PW: "LoginPW",
    KEY_LOGIN_REMEMBER: "LoginRemember",
    KEY_LAST_LOGIN: 'lastLogin',

    KEY_BIDDINGBOX_POS: 'biddingboxPos',
    KEY_BIDDINGBOX_POS_DIAGRAM: 'biddingboxPos-diagram',
    KEY_PASSWORD_HASH: 'PasswordHash',

    KEY_VERSION: 'Version',
    KEY_REGISTRY_VERSION: 'RegistryVersion',
    KEY_MIGRATION_VERSION: 'MigrationVersion',
    KEY_AUTO_ZOOM: 'AutoZoom',
    KEY_FONT_SIZE: 'FontSize',
    KEY_FONT_BOLD: 'FontBold',
    KEY_FONT_WEIGHT: 'FontWeight',
    KEY_LANGUAGE: 'Language',
    KEY_CARD_LANGUAGE: 'CardLanguage',
    KEY_LOGIN_ACCOUNT: 'LoginAccount',
    KEY_SOUND_BID_TURN: 'Beep0',
    KEY_SOUND_PLAY_TURN: 'Beep1',
    KEY_SOUND_PRIVATE_MSG: 'Beep2',
    KEY_SOUND_MEMBER_ENTRY: 'Beep3',
    KEY_DIAGRAM_MODE: 'DiagramMode',
    KEY_CARD_ORDER: 'CardOrder',
    KEY_CARD_FACE: 'CardFace',
    KEY_CARD_WIDE_SPACED: 'CardWideSpaced',
    KEY_CARD_IMAGES: 'CardImages',
    KEY_BIDDINGBOX_KIND: "BiddingBoxKind",
    KEY_FOUR_COLOUR_DECK: 'FourColourDeck',
    KEY_SHOW_BACK_OF_CARDS: 'ShowBackOfCard',
    KEY_BID_HINTS_ALL: 'BidHintsAll',
    KEY_MOVE_TRUMPS: 'MoveTrumps',
    KEY_SHOW_TRICKS_AFTER_LEAD: 'ShowTricksAfterLead',
    KEY_SHOW_TRICKS_COUNTER: 'ShowTrickCounter',
    KEY_HIDE_BIDDING_AFTER_LEAD: 'HideBidding',
    KEY_HIDE_CARDS_KIBITZING: 'hideCardsDuringKibitz',
    KEY_DEFAULT_PASS: 'DefaultPass',
    KEY_AUTO_SHOW_TABLES: 'AutoShowTables',
    KEY_AUTO_LOGIN: 'AutoLogin',
    KEY_AUTO_SHOW_CHAT: 'AutoShowChat',
    KEY_AUTO_SHOW_BOARD_RESULTS: 'AutoShowBoardResults',
    KEY_BACKGROUND_COLOUR_LM: 'BackgroundColourLM',
    KEY_BACKGROUND_COLOUR_DM: 'BackgroundColourDM',
    KEY_PLAY_BY_KEYBOARD: 'PlayByKeyboard',
    KEY_AUTO_ENTER_PBK: 'AutoEnterPBK',
    KEY_HINT_HOW_TO_PLAY: 'HintHowToPlay',
    KEY_HINT_PLAY_CONVENTION_CARD: 'HintPlayConventionCard',
    KEY_PLAY_BY: 'PlayBy',
    KEY_LAST_SCORINGMETHOD: 'lastPlayedScoringMethod',
    KEY_CAMERA_DEVICE: 'CameraDevice',
    KEY_MICROPHONE_DEVICE: 'MicrophoneDevice',
    KEY_AUDIO_OUTPUT_DEVICE: 'AudioOuputDevice',
    KEY_MUTE_MICROPHONE: 'MuteMicrophone',
    KEY_MUTE_CAMERA: 'MuteCamera',
    KEY_POSITION_PREFIX: 'pos_',
    KEY_HOST_INDEX: 'hostIndex',
    KEY_TOURNAMENT_PARTNER: 'TournamentPartner',
    KEY_ANIMATIONS: 'Animations',
    KEY_SINGLE_WINDOW: 'SingleWindow',
    KEY_ACTIVITIES_IN_LOBBY: 'ActivitiesInLobby',
    KEY_ACTIVITIES_WITH_TABLES: 'ActivitiesWithTables',
    KEY_ONTOP_CONTACTS: 'OnTopContacts',
    KEY_ONTOP_CC: 'OnTopConventionCard',
    KEY_ONTOP_BOARD_RESULTS: 'OnTopBoardResults',
    KEY_ONTOP_COMPETITION_RESULTS: 'OnTopCompetitionResults',

    KEY_URL_LIST: 'UrlList',
} as const;

export const keysToLog = [
    ConfigKey.KEY_VERSION,
    ConfigKey.KEY_LANGUAGE,
    ConfigKey.KEY_CARD_LANGUAGE,
    ConfigKey.KEY_SOUND_BID_TURN,
    ConfigKey.KEY_SOUND_PLAY_TURN,
    ConfigKey.KEY_SOUND_PRIVATE_MSG,
    ConfigKey.KEY_SOUND_MEMBER_ENTRY,
    ConfigKey.KEY_CARD_ORDER,
    ConfigKey.KEY_CARD_FACE,
    ConfigKey.KEY_CARD_WIDE_SPACED,
    ConfigKey.KEY_FOUR_COLOUR_DECK,
    ConfigKey.KEY_SHOW_BACK_OF_CARDS,
    ConfigKey.KEY_BID_HINTS_ALL,
    ConfigKey.KEY_MOVE_TRUMPS,
    ConfigKey.KEY_DEFAULT_PASS,
    ConfigKey.KEY_HINT_HOW_TO_PLAY,
    ConfigKey.KEY_HINT_PLAY_CONVENTION_CARD,
    ConfigKey.KEY_PLAY_BY,
    ConfigKey.KEY_LAST_SCORINGMETHOD,
    ConfigKey.KEY_CAMERA_DEVICE,
    ConfigKey.KEY_MICROPHONE_DEVICE,
    ConfigKey.KEY_AUDIO_OUTPUT_DEVICE,
    ConfigKey.KEY_HOST_INDEX,
    ConfigKey.KEY_SINGLE_WINDOW,
    ConfigKey.KEY_ACTIVITIES_IN_LOBBY,
    ConfigKey.KEY_ACTIVITIES_WITH_TABLES,
    ConfigKey.KEY_AUTO_SHOW_BOARD_RESULTS,
];

export const keysForLogin = [
    ConfigKey.KEY_VERSION,
    ConfigKey.KEY_SINGLE_WINDOW,
    ConfigKey.KEY_DIAGRAM_MODE,
    ConfigKey.KEY_CARD_FACE,
    ConfigKey.KEY_FOUR_COLOUR_DECK,
    ConfigKey.KEY_CARD_WIDE_SPACED,
    ConfigKey.KEY_PLAY_BY,
    ConfigKey.KEY_AUTO_ZOOM,
    ConfigKey.KEY_FONT_SIZE,
    ConfigKey.KEY_BIDDINGBOX_KIND,
    ConfigKey.KEY_DEFAULT_PASS,
    ConfigKey.KEY_CAMERA_DEVICE,
    ConfigKey.KEY_MICROPHONE_DEVICE,
    ConfigKey.KEY_AUDIO_OUTPUT_DEVICE,
    ConfigKey.KEY_ACTIVITIES_IN_LOBBY,
    ConfigKey.KEY_ACTIVITIES_WITH_TABLES,
];

export const keysToKeep = [
    ConfigKey.KEY_PASSWORD_HASH,
    ConfigKey.KEY_LOGIN_NAME,
    ConfigKey.KEY_LOGIN_PW,
    ConfigKey.KEY_LOGIN_REMEMBER,
    ConfigKey.KEY_LOGIN_ACCOUNT,
    ConfigKey.KEY_LANGUAGE,
    ConfigKey.KEY_CARD_LANGUAGE,
]